import { AgentDesktopState } from '@agent/agent-interface/agent-desktop-routing.module';
import { BasketAction, fromVisioBasket, VisioBasketAction } from '@agent/core/basket';
import { Load } from '@agent/core/basket/basket.action';
import { filter, map, merge, mergeMap, Observable, of, switchMap, withLatestFrom } from 'rxjs';

import { Action, ChannelType } from '@contact/upgrade';

import { SW } from '../models/basket';

export function loadGlobalEffect({ router, visioBasketService, basketStore }: SW): Observable<Action> {
  return basketStore.actions$.pipe(
    // filter action LOAD
    filter<Load>(action => action.type === BasketAction.ActionTypes.LOAD),
    // if agent is not on basket and load is a auto refresh
    withLatestFrom(router.currentUrl$),
    filter(([action, url]) => action.autoRefresh && url?.indexOf(AgentDesktopState.BASKET) === -1),
    // on each load action
    switchMap(() =>
      of({}).pipe(
        // refresh counter personal/common
        mergeMap(() => visioBasketService.globalCounter()),
        // map to success load action
        map(result => new VisioBasketAction.SuccessLoad(ChannelType.VISIO, result.label, result))
      )
    )
  );
}

export function loadBasketEffect({ router, visioBasketService, basketStore }: SW): Observable<Action> {
  return basketStore.actions$.pipe(
    // filter action LOAD
    filter<Load>(action => action.type === BasketAction.ActionTypes.LOAD),
    // if agent is not on basket or load is not a auto refresh
    withLatestFrom(router.currentUrl$),
    filter(([action, url]) => !action.autoRefresh || url?.indexOf(AgentDesktopState.BASKET) !== -1),
    // filter if current channel is VISIO
    filter(([action]) => action.channel === ChannelType.VISIO),
    // on each load action
    switchMap(([action]) =>
      of({}).pipe(
        // retrieve current visio basket model
        withLatestFrom(
          basketStore.pipe(fromVisioBasket.selectVisioBasket()),
          basketStore.pipe(fromVisioBasket.selectLabelByType(action.label)),
          basketStore.pipe(fromVisioBasket.selectCategoryByLabel(action.label))
        ),
        mergeMap(([_, channelModel, labelModel, categoryModel]) =>
          merge(
            // to get new requests
            visioBasketService.getRequests({
              ...channelModel,
              ...labelModel,
              ...categoryModel,
            }),
            // to update a counter
            visioBasketService.basketCounter(channelModel)
          )
        ),
        // map to success load action
        map(result => new VisioBasketAction.SuccessLoad(action.channel, result.label, result))
      )
    )
  );
}
